import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useStyles } from "./styles";
import TabPanel from "../TabPanel";
import { useCompanySegment } from "../../hooks/useCompanySegment";
import { useEffect, useState } from "react";

type TTab = {
  label: string;
  index: number;
  handleClick?: () => Promise<void>;
  children: React.ReactNode;
};

interface ITimelineProps {
  tabs: TTab[];
  padding: string;
  handleChange: any;
  value: number;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const TimelineColumn = ({
  tabs,
  padding,
  handleChange,
  value,
}: ITimelineProps) => {
  const styles = useStyles();
  const companySegment = useCompanySegment();
  const [hasSegment, setHasSegment] = useState(false);

  const isTabDisabled = () => {
    if (!hasSegment) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    if (companySegment && companySegment?.segment) {
      setHasSegment(true);
    }
  }, [companySegment]);

  const iconButton = (value: number) => {
    return (
      <Box
        className={`${styles.iconTimeline} ${
          !hasSegment && styles.iconTimelineDisabled
        }`}
      >
        {value}
      </Box>
    );
  };

  return (
    <Box padding={padding || "24px 0px 32px 0px"} className={styles.boxGlobal}>
      <Box className={styles.boxTabs}>
        <Tabs
          orientation="vertical"
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          className={styles.indicator}
        >
          {tabs.map((tab, index) => (
            <Tab
              disabled={isTabDisabled()}
              key={`${tab.label}-${index}`}
              icon={iconButton(tab.index + 1)}
              iconPosition="start"
              label={tab.label}
              className={styles.stepMenu}
              onClick={tab.handleClick}
              sx={{
                minWidth: `${tab.label.length}px`,
                minHeight: "56px",
                p: "8px 0px",
                marginBottom: "1rem !important",
              }}
              {...a11yProps(value)}
            />
          ))}
        </Tabs>
      </Box>
      <Box className={styles.boxInterception}></Box>
      {tabs.map((tab, index) => (
        <Box sx={{ flexGrow: 1 }} key={index}>
          <TabPanel index={tab.index} value={value} sx={{ width: "36.75rem" }}>
            {tab.children}
          </TabPanel>
        </Box>
      ))}
    </Box>
  );
};
